import { Stack } from '@chakra-ui/react';
import { Cart } from '@diamond/shared/types';
import { CardPromoInfo } from '@diamond/shared/ui';
import { useVoucherBannerData } from '@diamond/sol-buyer/utils';
import React from 'react';

interface VoucherBannerSummaryProps {
  selectedIds: Set<string>;
  cartItems?: Cart[];
}

export const VoucherBannerSummary = ({
  selectedIds,
  cartItems,
}: VoucherBannerSummaryProps) => {
  const voucherBanners = useVoucherBannerData(selectedIds, cartItems);

  if (voucherBanners.length === 0) {
    return null;
  }

  return (
    <Stack spacing="4" mt="4">
      {voucherBanners.map((banner) => (
        <CardPromoInfo
          key={banner.voucherId}
          type={banner.type}
          duration={banner.dateRange}
          text={banner.text}
          item={banner.item!}
          images={banner.images}
          savings={banner.savings}
          showFreeItemPrice={false}
          showVoucherIcon
        />
      ))}
    </Stack>
  );
};
